// Reglas de pantalla de los datos del paciente. La regla que manda es la del servidor
// (PatientDataRules.cs); esto sólo avisa antes de enviar para no hacer esperar al doctor.

// Por qué pedimos correo o celular; que el doctor no piense que es para publicidad
export const PATIENT_CONTACT_NOTE = 'Captura al menos uno. Nos sirve como identificador único de tu paciente y evita duplicados. No lo usamos para publicidad.';

/** Iniciales para el avatar: primera letra del nombre y primera del apellido. */
export function patientInitials(name: string, lastName: string): string
{
  const first = (name ?? '').trim().charAt(0);
  const last = (lastName ?? '').trim().charAt(0);

  return (first + last).toUpperCase();
}

/** Dental Monitoring necesita contactar al paciente: correo o celular, al menos uno. */
export function hasPatientContact(email: string, phone: string): boolean
{
  return !!(email ?? '').trim() || !!(phone ?? '').trim();
}

/** Género del paciente; mismos valores que el enum PatientGender del servidor. */
export enum PatientGender
{
  Male = 1,
  Female = 2,
}

export const PATIENT_GENDERS: { value: PatientGender, label: string }[] = [
  { value: PatientGender.Male, label: 'Masculino' },
  { value: PatientGender.Female, label: 'Femenino' },
];

/** Texto para mostrar; vacío en pacientes viejos que no lo tienen capturado. */
export function patientGenderLabel(gender: PatientGender | null | undefined): string
{
  return PATIENT_GENDERS.find(g => g.value === gender)?.label ?? '';
}
